/** @format */

import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import {
  homefieldIconDeleteFill,
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconStarRatingFill0Percent,
} from '@dsg-tech/homefield-angular-icons';

import { HmfButtonComponent, HmfSkeletonComponent } from '@dsg-tech/homefield-angular';
import { BreakpointsService } from '@shared/data-access/services';
import { BreakPointNew } from '@shared/data-access/enums';

@Component({
  selector: 'compare-components-skeleton-compare-grid-product-card',
  imports: [HmfButtonComponent, HomefieldIconLibraryModule, HmfSkeletonComponent],
  templateUrl: './skeleton-compare-grid-product-card.component.html',
  styleUrl: './skeleton-compare-grid-product-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonCompareGridProductCardComponent {
  protected readonly breakpointsService = inject(BreakpointsService);
  private readonly hmfIconService = inject(HomefieldIconsLibraryService);

  readonly isCompact = input.required<boolean>();

  protected readonly BreakPointNew = BreakPointNew;

  constructor() {
    this.hmfIconService.registerIcons([
      homefieldIconStarRatingFill0Percent,
      homefieldIconDeleteFill,
    ]);
  }
}
